import { i18n } from "i18next";
import log from "loglevel";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "react-use";
import Refiner from "refiner-js";

import config from "@/config";
import { Identity } from "@/shared/domain";

import { useCookieConsent } from "./shared/contexts";
import { useAuth } from "./shared/hooks";

let lastUser = null;

interface UserRefiner {
    id?: string;
    language?: string;
    email?: string;
    name?: string;
}

const createRefinerUser = (i18: i18n, user: Identity): UserRefiner => {
    if (user.isAuthenticated) {
        const refinerUser: UserRefiner = {
            id: user.id,
            language: i18.language,
        };
        if (config.NODE_ENV === "development") {
            refinerUser.email = user.email;
            refinerUser.name = user.name;
        }
        log.debug("[refiner] setIdentifyUser: ", refinerUser);
        return user;
    }
    log.debug("[refiner] clear user");
    return {};
};

export const useUserFeedback = (): { incUsageCount: () => void } => {
    const { categories } = useCookieConsent();
    const { user } = useAuth();
    const { i18n: i18 } = useTranslation();
    const [feedback, storeFeedback] = useLocalStorage<number>("feedbackCnt", 0);
    if (!categories.includes("performance"))
        return {
            incUsageCount: () => {
                /* noop  */
            },
            // setIdentity: () => {
            //     /* noop  */
            // },
        };

    const incUsageCount = (number = 1) => {
        if (!config.IS_PROD) {
            return;
        }

        if (lastUser !== user) {
            lastUser = user;
            Refiner("identifyUser", createRefinerUser(i18, user));
            Refiner("setProject", config.REFINER_TOKEN);
        }

        log.debug("[refiner] Feedback Cnt: ", feedback);
        storeFeedback(feedback + number);
        if (feedback > config.REFINER_FEEDBACK_COUNT) {
            log.debug("[refiner] showForm: ", i18.language);
            switch (i18.language) {
                case "en":
                    Refiner("showForm", config.REFINER_SURVEY_EN);
                    break;
                case "nl":
                    Refiner("showForm", config.REFINER_SURVEY_NL);
                    break;
                case "fr":
                    Refiner("showForm", config.REFINER_SURVEY_FR);
                    break;
                case "de":
                    Refiner("showForm", config.REFINER_SURVEY_DE);
                    break;
            }
        }
    };
    return { incUsageCount };
};
